import {css} from '@emotion/react'
import {LoadingOutlined} from '@ant-design/icons'
import {useAiContext} from './AiContext.mjs'
import {MessageButtonCopy} from './MessageButtonCopy.jsx'
import {Markdown} from './Markdown/Markdown.jsx'

const cssResponseBody = css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    overflow: 'hidden',
})

const cssAnswer = css({
    width: '100%',
})

const cssThink = css({
    color: '#8b8b8b',
    fontSize: 12,
    lineHeight: 1.6,
    paddingLeft: 12,
    borderLeft: '2px solid #e5e5e5',
})

const cssThinkCompact = css({
    lineHeight: 1.4,
    paddingLeft: 8,
})

const cssTools = css({
    display: 'flex',
})

const cleanContent = s => s.replace(/(===TABLE_(START|END)===)/g, '')

export const ResponseBody = ({message, ...props}) => {
    const ai = useAiContext()
    const {content, status} = message

    const tools = (
        <div css={cssTools}>
            <MessageButtonCopy message={message} />
        </div>
    )

    if (! content) {
        return (
            <div
                css={cssResponseBody}
                {...props}
            >
                <LoadingOutlined />
            </div>
        )
    }
    else if (content.startsWith('<think>')) {
        const i = content.indexOf('</think>')

        if (- 1 < i) {
            const think = content.slice(7, i)
            const answer = cleanContent(content.slice(i + 8))

            return (
                <div
                    css={cssResponseBody}
                    {...props}
                >
                    <Markdown
                        css={[
                            cssThink,
                            ai.compactView && cssThinkCompact
                        ]}
                    >
                        {think}
                    </Markdown>

                    <Markdown css={cssAnswer}>
                        {answer}
                    </Markdown>

                    {tools}
                </div>
            )
        }
        else if ('done' === status) {
            const answer = content.slice(7)

            return (
                <div
                    css={cssResponseBody}
                    {...props}
                >
                    <Markdown css={cssAnswer}>
                        {answer}
                    </Markdown>

                    {tools}
                </div>
            )
        }
        else {
            const think = content.slice(7)

            return (
                <div
                    css={cssResponseBody}
                    {...props}
                >
                    <Markdown
                        css={[
                            cssThink,
                            ai.compactView && cssThinkCompact
                        ]}
                    >
                        {think}
                    </Markdown>

                    {tools}
                </div>
            )
        }
    }
    else {
        return (
            <div
                css={cssResponseBody}
                {...props}
            >
                <Markdown css={cssAnswer}>
                    {cleanContent(content)}
                </Markdown>

                {tools}
            </div>
        )
    }
}
